import { render, staticRenderFns } from "./goodsNotice.vue?vue&type=template&id=5f45ab80"
import script from "./goodsNotice.vue?vue&type=script&lang=js"
export * from "./goodsNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports